import { withStyles } from '@material-ui/core';

import ImageThumb from './component';
import styles from './styles';

export default withStyles(styles)(ImageThumb);
